/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import AppConfig from '../stores/config';
import { CONFIRMATION_BOX_BTN_IDS } from '../utils/modelMapper/appModelMapper/confirmationDialog/confirmationDialogConstants';

const feedbackOptionsMap = {
    InstallerStuck: 'The installer is stuck',
    InstallerTakingTooLong: 'The installer is taking too long',
    InstallDifferentApp: 'I want to install a different app',
    ChangedMind: 'I changed my mind',
    UpdaterStuck: 'The updater is stuck',
    UpdaterTakingTooLong: 'The updater is taking too long',
    UpdateOrInstallDifferentApp: 'I want to update or install a different app',
    SomethingElse: 'Something else',
};

class CancelFeedbackDialogAnalytics {
    feedbackOptionSelected = null;

    feedbackOptionText = '';

    set feedbackOptionSelection(e) {
        this.feedbackOptionSelected = e;
        if (e !== 'SomethingElse') {
            this.feedbackOptionText = '';
        }
    }

    set feedbackSomethingElseText(text) {
        this.feedbackOptionText = text;
    }

    sendButtonClickAnalytics(actionId, appModel, data) {
        const feedbackdata = {
            feedbackOption: this.feedbackOptionSelected,
            feedbackOptionText: feedbackOptionsMap[this.feedbackOptionSelected],
        };

        if (this.feedbackOptionText) {
            feedbackdata.feedbackFormData = this.feedbackOptionText;
        }

        if (actionId === CONFIRMATION_BOX_BTN_IDS.WARNING) { /* cancel installation */
            this.sendAnalytics({
                event: {
                    workflow: 'Apps',
                    type: 'click',
                    subtype: 'yes',
                    value: (this.feedbackOptionSelected ? JSON.stringify(feedbackdata) : ''),
                    subcategory: (data && data.appSectionFilter ? `${data.appSectionFilter}:Install Cancel` : ''),
                },
                content: {
                    id: appModel.sapcode,
                    name: appModel.appFamilyName,
                    category: appModel.platform,
                    version: appModel.codexVersion,
                },
                ui: {
                    view_type: 'Operations Menu',
                },
            });
        } else if (actionId === CONFIRMATION_BOX_BTN_IDS.SECONDARY) { /* continue installation */
            this.sendAnalytics({
                event: {
                    workflow: 'Apps',
                    type: 'click',
                    subtype: 'no',
                    subcategory: (data && data.appSectionFilter ? `${data.appSectionFilter}:Install Cancel` : ''),
                },
                content: {
                    id: appModel.sapcode,
                    name: appModel.appFamilyName,
                    category: appModel.platform,
                    version: appModel.codexVersion,
                },
                ui: {
                    view_type: 'Operations Menu',
                },
            });
        }
    }

    sendRenderAnalytics(appModel, data) {
        this.sendAnalytics({
            event: {
                workflow: 'Apps',
                type: 'render',
                subtype: 'feedback',
                subcategory: (data && data.appSectionFilter ? `${data.appSectionFilter}:Install Cancel` : ''),
            },
            content: {
                id: appModel.sapcode,
                name: appModel.appFamilyName,
                category: appModel.platform,
                version: appModel.codexVersion,
            },
            ui: {
                view_type: 'Operations Menu',
            },
        });
    }

    sendAnalytics(analyticObject) {
        AppConfig.analyticsCallback({
            analyticObjectList: [analyticObject],
        });
    }
}

export default new CancelFeedbackDialogAnalytics();
